// CaptchaControlView.js
import BaseControlView from 'BaseControlView';
import constants        from "Constants";
import template from 'advanced-visuals/control-captcha.ejs';
import eventBus         from 'EventBus.js';

//=====================================================================
//
// An instance of this view represents a Captcha control.
//
// Brad Trebilcock, January, 18 2016
//
//=====================================================================
class CaptchaControlView extends BaseControlView  {

    initialize(opts) {

        super.initialize(opts);

        this.template = template;
        this.subfamily = constants.CONTROL_INSTANCE;
        this.family = constants.CONTROL_ADVANCED_INPUTS;

        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'CaptchaControlView';
    }
}

export default CaptchaControlView;

